import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { CaratLeft } from '@weee-fe/kunlunicon';
import { defaultBack } from '@/components/common/HeaderNew';
import { useRouter } from 'next/router';

type ComponentProps = {
  currentPageTitle: string | ReactNode;
  backTitle: string;
  rightNode?: ReactNode;
  wrapperClassName?: string;
  caratSize?: number;
  hideBack?: boolean;
  headerColor?: string;
  textColorOverwriteClass?: string;
  oldHeaderOverlayPortion?: ReactNode;
  oldHeaderMainCTA?: ReactNode;
  oldHeaderMainCTAInlineWithBack?: ReactNode;
  pageNavHeaderWrapperClassOverwrite?: string;
  onBack?: () => string;
};

export const defaultCaratSize = 14;

const PageNavHeader = (props: ComponentProps) => {
  const {
    currentPageTitle,
    backTitle,
    rightNode,
    wrapperClassName = '',
    caratSize = defaultCaratSize,
    hideBack = false,
    headerColor = 'transparent',
    textColorOverwriteClass,
    oldHeaderOverlayPortion,
    oldHeaderMainCTA,
    oldHeaderMainCTAInlineWithBack,
    pageNavHeaderWrapperClassOverwrite = '',
    onBack
  } = props;

  const router = useRouter();
  const query = router?.query as {
    [key: string]: any;
  };

  const backNavigation = () => {
    if (
      document &&
      (document.referrer.includes('/account/help') ||
        document.referrer.includes('/account/contact-us') ||
        document.referrer?.includes?.('/account/contact-us') ||
        document.referrer?.includes?.('/account/help'))
    ) {
      return router.back();
    }
    if (query.ws === 'message_center') {
      return router.back();
    }

    if (onBack) {
      return onBack();
    }

    try {
      return defaultBack(router);
    } catch (e) {
      console.error('[PageNavHeader] error on defaultBack(); using router.back(). Error:', e);
      return router.back();
    }
  };

  const backLabel = backTitle ? backTitle : 'Back';

  return (
    <div
      className={twMerge(
        wrapperClassName,
        'px-500 pt-400 pb-200 mb-0',
        textColorOverwriteClass,
        pageNavHeaderWrapperClassOverwrite
      )}
      style={{ backgroundColor: headerColor }}>
      <div className="flex items-center justify-between relative w-full min-h-[20px]">
        <button
          type="button"
          aria-label={backLabel}
          className={twMerge(
            'border-none bg-transparent cursor-pointer appearance-none text-inherit',
            oldHeaderMainCTAInlineWithBack ? 'justify-between' : '',
            'enki-body-xs flex gap-[6px] items-center -ml-[3px] capitalize',
            textColorOverwriteClass ? textColorOverwriteClass : 'text-surface-100-fg-minor'
          )}
          onClick={backNavigation}>
          {!hideBack && (
            <span data-testid="wid-page-nav-header-back-button" className="flex gap-100 items-center">
              <CaratLeft width={caratSize} height={caratSize} className={twMerge('z-[2]')} />
              {backLabel}
            </span>
          )}
        </button>
        {!oldHeaderMainCTAInlineWithBack && (
          <div
            data-testid="wid-page-nav-header-title"
            className={
              'enki-heading-sm-strong !text-[14px] flex items-center justify-center text-center absolute left-16 right-16 line-clamp-2'
            }>
            {currentPageTitle}
          </div>
        )}
        <div className={'relative flex items-center justify-between min-h-[20px]'}>
          {!oldHeaderMainCTAInlineWithBack && (rightNode || oldHeaderMainCTA) ? (
            <div data-testid="wid-page-nav-header-right-node" className="flex gap-4">
              {!!rightNode && <>{rightNode}</>}
              {!!oldHeaderMainCTA ? <>{oldHeaderMainCTA}</> : null}
            </div>
          ) : null}

          {oldHeaderMainCTAInlineWithBack && <>{oldHeaderMainCTAInlineWithBack}</>}
        </div>
      </div>
      {!!oldHeaderOverlayPortion ? <div className="flex flex-col mt-200">{oldHeaderOverlayPortion}</div> : null}
    </div>
  );
};

export default PageNavHeader;
